import { render, staticRenderFns } from "./CustomAttributes.vue?vue&type=template&id=61c09c3c&scoped=true&"
import script from "./CustomAttributes.vue?vue&type=script&lang=js&"
export * from "./CustomAttributes.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributes.vue?vue&type=style&index=0&id=61c09c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c09c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c09c3c')) {
      api.createRecord('61c09c3c', component.options)
    } else {
      api.reload('61c09c3c', component.options)
    }
    module.hot.accept("./CustomAttributes.vue?vue&type=template&id=61c09c3c&scoped=true&", function () {
      api.rerender('61c09c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/customAttributes/CustomAttributes.vue"
export default component.exports